import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { bindNavigation } from "./navigation.ts";

export default function NavigationBridge() {
  const navigate = useNavigate();
  useEffect(function () {
    return bindNavigation(navigate);
  }, [navigate]);
  return null;
}
